import { call, put, takeLatest } from 'typed-redux-saga'
import { LeadNS, leadApi, leadSlice, commonPPSlice, getRealError } from 'Pages/partnerProfile'
import { authSlice } from 'Pages/auth'
import { noop, takeEveryUnique } from 'Helpers'
import { errorHandler, LocalStorage } from 'Modules'
import { agreementApi } from 'Pages/admin'
import { Deserialize } from 'cerialize'

function* createLead(action: LeadNS.CrateLead) {
	try {
		const { lead, callback } = action.payload
		yield* put(leadSlice.actions.clearAll)
		yield* put(commonPPSlice.actions.setIsLoading(true))
		const res = yield* call(leadApi.createLead, lead)
		yield* put(leadSlice.actions.setLead(res))
		callback?.()
	} catch (errors) {
		const { errorCallback } = action.payload
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
		errorCallback?.(errors?.data?.errors?.[0])
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

function* activateLead(action: LeadNS.ActivateLead) {
	try {
		const { token, lead, callback } = action.payload
		yield* put(commonPPSlice.actions.setIsLoading(true))
		yield* call(leadApi.activateLead, token, lead)
		callback?.()
	} catch (errors) {
		const { errorCallback } = action.payload
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
		yield* put(leadSlice.actions.setRealErrorLead(getRealError(errors)))
		errorCallback?.(errors?.data?.errors?.[0])
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

function* validateLead(action: LeadNS.ValidateLead) {
	try {
		const { token, lead, callback } = action.payload
		yield* put(commonPPSlice.actions.setIsLoading(true))
		yield* call(leadApi.validateLead, token, lead)
		callback?.()
	} catch (errors) {
		const { errorCallback } = action.payload
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
		yield* put(leadSlice.actions.setRealErrorLead(getRealError(errors)))
		errorCallback?.(errors?.data?.errors?.[0])
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

function* completeLead(action: LeadNS.CompleteLead) {
	try {
		const { token, lead, callback } = action.payload
		yield* put(commonPPSlice.actions.setIsLoading(true))
		yield* call(leadApi.completeLead, token, lead)
		callback?.()
	} catch (errors) {
		const { errorCallback } = action.payload
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
		yield* put(leadSlice.actions.setRealErrorLead(getRealError(errors)))
		errorCallback?.(errors?.data?.errors?.[0])
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

function* getTokenLead(action: LeadNS.GetTokenLead) {
	try {
		const { token, callback } = action.payload
		yield* put(commonPPSlice.actions.setIsLoading(true))
		const res = yield* call(leadApi.getTokenLead, token)
		yield* put(leadSlice.actions.setLead(res))
		callback?.()
	} catch (errors) {
		const { errorCallback } = action.payload
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
		errorCallback?.(errors?.data?.errors?.[0])
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

function* getDictIncorporationForm(action: LeadNS.GetDictIncorporationForm) {
	try {
		yield* put(commonPPSlice.actions.setIsLoading(true))
		const res = yield* call(leadApi.getDictIncorporationForm)
		yield* put(leadSlice.actions.setDictIncorporationForm(res))
	} catch (errors) {
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

function* refreshSmsLead(action: LeadNS.RefreshSmsLead) {
	try {
		const { id, callback } = action.payload
		yield* put(commonPPSlice.actions.setIsLoading(true))
		const res = yield* call(leadApi.refreshSmsLead, id)
		callback?.(res)
	} catch (errors) {
		const { errorCallback } = action.payload
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
		errorCallback?.(errors?.data?.errors?.[0])
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

function* refreshEmailLead(action: LeadNS.RefreshEmailLead) {
	try {
		const { data, callback } = action.payload
		yield* put(commonPPSlice.actions.setIsLoading(true))
		const res = yield* call(leadApi.refreshEmailLead, data)
		callback?.(res)
	} catch (errors) {
		const { errorCallback } = action.payload
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
		errorCallback?.(errors?.data?.errors?.[0])
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

function* loginUserLead(action: LeadNS.LoginUserLead) {
	try {
		LocalStorage.setUserSettings({ isPotentialPartner: true })
		yield* put(
			authSlice.actions.login({
				data: action.payload,
				callback: noop,
			})
		)
	} catch (errors) {
		// eslint-disable-next-line no-console
		console.log('Login: ', errors)
	}
}

function* recreateEmailLead(action: LeadNS.RefreshEmailLead) {
	try {
		const { data, callback } = action.payload
		yield* put(commonPPSlice.actions.setIsLoading(true))
		const res = yield* call(leadApi.recreateEmailLead, data)
		callback?.(res)
	} catch (errors) {
		const { errorCallback } = action.payload
		yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
		errorCallback?.(errors?.data?.errors?.[0])
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

export function* getAdAgreement(action: LeadNS.GetAdAgreement) {
	try {
		yield* put(commonPPSlice.actions.setIsLoading(true))
		const { params } = action.payload
		const res = yield* call(agreementApi.getAll, params)
		const id = res?.entries?.[0]?.id
		if (id) {
			const adAgreement = yield* call(agreementApi.getOne, id)
			yield* put(leadSlice.actions.setAdAgreement(Deserialize(adAgreement)))
		}
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
	}
}

export function* leadSaga() {
	yield* takeLatest(leadSlice.actions.crateLead.type, createLead)
	yield* takeEveryUnique(leadSlice.actions.activateLead.type, activateLead)
	yield* takeLatest(leadSlice.actions.validateLead.type, validateLead)
	yield* takeLatest(leadSlice.actions.completeLead.type, completeLead)
	yield* takeLatest(leadSlice.actions.getTokenLead.type, getTokenLead)
	yield* takeLatest(leadSlice.actions.getDictIncorporationForm.type, getDictIncorporationForm)
	yield* takeLatest(leadSlice.actions.refreshSmsLead.type, refreshSmsLead)
	yield* takeLatest(leadSlice.actions.refreshEmailLead.type, refreshEmailLead)
	yield* takeLatest(leadSlice.actions.loginUserLead.type, loginUserLead)
	yield* takeLatest(leadSlice.actions.recreateEmailLead.type, recreateEmailLead)
	yield* takeLatest(leadSlice.actions.getAdAgreement.type, getAdAgreement)
}
